import { TimelineStore } from '../timeline.store';
import { TIMELINE_CANVAS_WIDTH } from '../../../constants';
import { getIntermediateValues } from '../../../shared/helpers/get-intermediate-values';
import { lowerDividend } from '../../../shared/helpers/math.helpers';
import { RecorderStore } from '../../stores/recorder.store';
var TimelineLayersComponent = /** @class */ (function () {
    function TimelineLayersComponent(timelineStore, recorderStore) {
        this.timelineStore = timelineStore;
        this.recorderStore = recorderStore;
        this.canvasPositions = [];
    }
    Object.defineProperty(TimelineLayersComponent.prototype, "layerIds", {
        get: function () {
            return this.recorderStore.recordData.layerIds;
        },
        enumerable: true,
        configurable: true
    });
    TimelineLayersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.updateCanvasPositions();
        this.timelineChangeSubscriber = this.timelineStore.change
            .subscribe(function () { return _this.updateCanvasPositions(); });
    };
    TimelineLayersComponent.prototype.ngOnDestroy = function () {
        this.timelineChangeSubscriber.unsubscribe();
    };
    TimelineLayersComponent.prototype.updateCanvasPositions = function () {
        this.canvasPositions = this.getCanvasPositions();
    };
    TimelineLayersComponent.prototype.getCanvasPositions = function () {
        var step = this.timelineStore.convertPixelsToMilliseconds(TIMELINE_CANVAS_WIDTH);
        var startValue = lowerDividend(this.timelineStore.startVisiblePosition, step);
        var endValue = lowerDividend(this.timelineStore.endVisiblePosition, step);
        if (this.shouldPositionsUpdate(startValue, endValue, step)) {
            this.previousStep = step;
            this.previousStartValue = startValue;
            this.previousEndValue = endValue;
            return getIntermediateValues(startValue, endValue, step);
        }
        else {
            return this.canvasPositions;
        }
    };
    TimelineLayersComponent.prototype.shouldPositionsUpdate = function (startValue, endValue, step) {
        return startValue !== this.previousStartValue ||
            endValue !== this.previousEndValue ||
            step !== this.previousStep;
    };
    return TimelineLayersComponent;
}());
export { TimelineLayersComponent };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layers/timeline-layers.component.ts.pre-build-optimizer.js